import { AutorizationResponseType } from '@/shared/types/app.types.ts';

export const isReportsPermission = (user: AutorizationResponseType) =>
	user?.permissions?.some((permission) => permission === 'fsoft.booking.api.reports');
